/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SnapshotDateFilters {
  /**
  * Minimum date for filtering snapshots, inclusive. If not specified, all snapshots from the earliest available date will be included. The date should be in ISO 8601 format (YYYY-MM-DD). 
  */
  'minDate'?: string;
  /**
  * Maximum date for filtering snapshots, inclusive. If not specified, all snapshots up to the latest available date will be included. The date should be in ISO 8601 format (YYYY-MM-DD). 
  */
  'maxDate'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "minDate",
      "baseName": "MinDate",
      "type": "string",
      "format": ""
    },
    {
      "name": "maxDate",
      "baseName": "MaxDate",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SnapshotDateFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

